module.exports = __webpack_public_path__ + "media/img/icons/venue_group-f242860aa4249ab9145cff3ce764bea3.png";